import React from 'react';
import { Box, Table, Tooltip, InfoIcon } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { StatusDot } from '@epi-pages/Reports/TopupReports/TopupReports.styles';
import { formatDate, reportStatusesColors } from '@epi-pages/Reports/utils';
import { CardOrdersTableBodyProps } from '@epi-models/pages/Reports';

export const CardOrdersTableBody = ({
  ordersHistory
}: CardOrdersTableBodyProps) => {
  const { t } = useTranslation();
  const { primaryFrontColor } = useTheme();

  return (
    <>
      {ordersHistory.map(cardOrder => (
        <Table.Row key={cardOrder.tableRowKey ?? cardOrder.orderDate}>
          <Table.Cell>
            <Box display="flex" alignItems="center" lineHeight="25px">
              {formatDate(cardOrder.orderDate)}
            </Box>
          </Table.Cell>
          <Table.Cell>
            <Box display="flex" alignItems="center">
              {cardOrder.userFirstName} {cardOrder.userLastName}
            </Box>
          </Table.Cell>
          <Table.Cell>
            <Box display="flex" alignItems="center" lineHeight="25px">
              {cardOrder.userEmail}
            </Box>
          </Table.Cell>
          <Table.Cell>
            <Box display="flex" alignItems="center">
              <StatusDot
                $dotColor={
                  reportStatusesColors[
                    `card_order_status.${cardOrder.cardOrderStatus}`
                  ]
                }
              />
              {t(`${cardOrder.transactionLabel}`)}
              {t(`${cardOrder.tooltipLabel}`) && (
                <Tooltip
                  arrow
                  placement="top"
                  id={`${cardOrder.orderDate}-tooltip`}
                  componentsProps={{ tooltip: { sx: { maxWidth: '500px' } } }}
                  title={<Trans i18nKey={`${cardOrder.tooltipLabel}`} />}
                >
                  <Box id={`${cardOrder.orderDate}-info-icon`} ml={1}>
                    <InfoIcon color={primaryFrontColor} />
                  </Box>
                </Tooltip>
              )}
            </Box>
          </Table.Cell>
          <Table.Cell>
            <Box display="flex" alignItems="center">
              {t(
                `containers.deposit_money.card_orders_tab.card_type.${cardOrder.cardType}`
              )}
            </Box>
          </Table.Cell>
        </Table.Row>
      ))}
    </>
  );
};
